export const environment = {
    
    // apiEndpoint: 'http://localhost:21021',
    
    QNYImgUrl: 'https://cdn.weibinyi.com/',
    QNYImgUrlYS: '?imageView2/4/w/400/h/600/q/100',

    wxredirecturi: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx46a1913d55fa5abf&redirect_uri=https://niannian.weibinyi.com/&response_type=code&scope=snsapi_userinfo&state=home#wechat_redirect',

    apiEndpoint: 'https://api.weibinyi.com',
    
    fgapiEndpoint: 'https://fgapi.weibinyi.com',
    

    domainUrl: "https://niannian.weibinyi.com",
    appid: "wx46a1913d55fa5abf",

};